






import { Component, Prop, Mixins } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IOrder } from "@/models/orders";
import Context from "@/mixins/context";

@Component
export default class CancelOrderCta extends Mixins(Context) {
  // Props
  @Prop({ required: true })
  public order!: IOrder;
  // Getters
  public get isVisible() {
    return this.$store.getters[`data/${DataModules.ORDERS}/isDue`](this.order);
  }
  // Methods
  public openCancelOrderModal() {
    return this.$store.dispatch(
      `data/${DataModules.CONTRACTS}/${
        this.isAdmin
          ? "openAdminCancellationModal"
          : "openClientCancellationModal"
      }`,
      {
        props: {
          contractId: this.order.contract_id
        },
        events: {
          "contract-updated": () => this.$emit("cancelled")
        }
      }
    );
  }
}
